import React from "react";

const Brandfolder = (props) => (
  <div className="adobe-brandfolder">
    <p>{props.name}</p>
  </div>
);

export default Brandfolder;
